import React from 'react'
import { storiesOf } from '@storybook/react'
import withReadme from 'storybook-readme/with-readme'

// Digital-Commons Theming
import { ThemeProvider } from 'styled-components'
import { getBaseTheme } from '../..'

// Component to surface in storybook
import MultiSelectTree from '.'
import { data } from './demos/dummy-data/data-big.js'
import readme from './readme.md'

// Story Setup
const stories = storiesOf('Digital-Commons/Multi Select Tree', module)

stories.addDecorator(withReadme(readme))

// Theming setup
const mode = 'refinitiv'
const baseTheme = getBaseTheme({ mode })
const builtTheme = {
  mode,
  ...baseTheme
}

class Demo extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      values: null
    }

    this.buttonStyle = {
      position: 'relative',
      top: '-20px',
      marginRight: '15px',
      background: 'transparent',
      textDecoration: 'underline',
      color: '#888'
    }
  }

  onChange = values => {
    console.log(`[MultiSelectTree.onChange] number of selected values: ${values.length} \nvalues: [${values.join(', ')}]`)
    this.setState({ values })
  }

  clearAll = () => {
    this.setState({ values: null })
  }

  setValues = () => {
    this.setState({ values: ['BNSEM-3', 'BLE-118'] })
  }

  render() {
    return (
      <div style={{margin: '50px auto', width: '50%'}}>

        <a href='javascript:void(0)' onClick={this.clearAll} style={this.buttonStyle}>Clear all</a>
        <a href='javascript:void(0)' onClick={this.setValues} style={this.buttonStyle}>Set values</a>

        <MultiSelectTree
          data={data.tree}
          onChange={this.onChange}
          label='Exchanges'
          searchPlaceholder='Search in list...'
          searchNoResults='No results'
          values={this.state.values}
        />

        Choose from a nested list of values.

      </div>
    )
  }
}

// Stories
stories
  .add('Default', () => (
    <ThemeProvider theme={builtTheme}>
      <Demo />
    </ThemeProvider>
  ))
